
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hunk-quiz-20",
      function () {
        return require("private-next-pages/hunk-quiz-20.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hunk-quiz-20"])
      });
    }
  